import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";
import { PageContent } from "../../../../../../styles/global/Pages.styled";
import clsx from "clsx";
import { Widget } from "../../../../Atomics/Widget";
import Theme from "../../../../../../styles/Theme/Theme";
import { t } from "i18next";
import logger from "../../../../../../server/server";
import { useAuthContext } from "../../../../../../contexts/AuthContext";

// Componente principal que exibe o histórico de consumo energético de um edifício
export const BuildingParkingDA = ({ item, currentFloor, ...props }) => {
  // Hook de tradução
  const { t } = useTranslation();
  const { user, tenant } = useAuthContext();
  const [selectedDay, setSelectedDay] = useState();

  useEffect(() => {
    logger.info("User " + user?.Username + " entered BuildingParkingDA successfully! Tenant: " + tenant);
  }, []);

  // Refetch dos dados quando o mês ou ano selecionados mudam
  // useEffect(() => {
  //   refetchBuildingParkingDA();
  // }, [selectedDay]);

  return (
    <>
      {/* Conteúdo da página com layout e estrutura com Col e Rows */}
      <PageContent className={clsx("building_room_details", props?.className)}>
        <Row gutter={[16, 16]}>
          {/* Define o layout de linhas com largura total */}
          <Col span={24} style={{ alignContent: "center" }}>
            <Row>
              <Col span={10}>
                <Row>
                  <Col span={24}>
                    <h3>
                      {item?.name} | {t("Parking").toLocaleUpperCase()}{" "}
                      {/* Changes the title to upperCase and translates it */}
                    </h3>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          {/* Widgets com dados de consumo energético */}
          <Col span={24}>
            <Row gutter={[16, 32]}>
              <Col span={6}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Seats Taken"),
                    icon: null,
                    charts: [
                      {
                        chartType: "bigNumberChart",
                        chartId: "bigNumberChartOne",
                        height: "111px",
                        data: parking?.seatsTaken,
                      },
                    ],
                  }}
                />
              </Col>
              <Col span={6}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Reserved Seats"),
                    icon: null,
                    charts: [
                      {
                        chartType: "bigNumberChart",
                        chartId: "bigNumberChartOne",
                        height: "111px",
                        data: parking?.reservedSeats,
                      },
                    ],
                  }}
                />
              </Col>
              <Col span={6}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Average Length of Stay"),
                    icon: null,
                    charts: [
                      {
                        chartType: "bigNumberChart",
                        chartId: "bigNumberChartOne",
                        height: "111px",
                        data: parking?.averageLengthStay,
                      },
                    ],
                  }}
                />
              </Col>
              <Col span={6}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Seat Availability"),
                    icon: null,
                    charts: [
                      {
                        chartType: "bigNumberChart",
                        chartId: "bigNumberChartOne",
                        height: "111px",
                        data: parking?.seatAvailability,
                      },
                    ],
                  }}
                />
              </Col>
              <Col span={24}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Total Number of Vehicles Throughout the Day"),
                    icon: null,
                    dropdowns: [
                      {
                        data: [
                          { value: 1, label: t("All") },
                          { value: 2, label: t("Contracts") },
                          { value: 3, label: t("daily") },
                        ],
                        value: selectedDay,
                        functionChange: (value) => setSelectedDay(value),
                        width: "200px",
                      },
                    ],
                    charts: [
                      {
                        chartType: "areaChartApex",
                        chartId: "areaChartApex",
                        height: "300px",
                        data: {
                          "series": [
                            {
                              "name": t("Occupation"),
                              "data": [
                                {
                                  "x": "00:00",
                                  "y": 50
                                },
                                {
                                  "x": "01:00",
                                  "y": 53
                                },
                                {
                                  "x": "03:00",
                                  "y": 51
                                },
                                {
                                  "x": "04:00",
                                  "y": 50
                                },
                                {
                                  "x": "05:00",
                                  "y": 48
                                },
                                {
                                  "x": "06:00",
                                  "y": 49
                                },
                                {
                                  "x": "07:00",
                                  "y": 50
                                },
                                {
                                  "x": "08:00",
                                  "y": 38
                                },
                                {
                                  "x": "09:00",
                                  "y": 28
                                },
                                {
                                  "x": "10:00",
                                  "y": 26
                                },
                                {
                                  "x": "11:00",
                                  "y": 23
                                },
                                {
                                  "x": "12:00",
                                  "y": 55
                                },
                                {
                                  "x": "13:00",
                                  "y": 41
                                },
                                {
                                  "x": "14:00",
                                  "y": 20
                                },
                                {
                                  "x": "15:00",
                                  "y": 20
                                },
                                {
                                  "x": "16:00",
                                  "y": 23
                                },
                                {
                                  "x": "17:00",
                                  "y": 32
                                },
                                {
                                  "x": "18:00",
                                  "y": 30
                                },
                                {
                                  "x": "19:00",
                                  "y": 27
                                },
                                {
                                  "x": "20:00",
                                  "y": 12
                                },
                                {
                                  "x": "21:00",
                                  "y": 28
                                },
                                {
                                  "x": "22:00",
                                  "y": 33
                                },
                                {
                                  "x": "23:00",
                                  "y": 57
                                },
                                {
                                  "x": "24:00",
                                  "y": 47
                                }
                              ]
                            },
                            {
                              "name": t("Capacity"),
                              "data": [
                                {
                                  "x": "00:00",
                                  "y": 70
                                },
                                {
                                  "x": "01:00",
                                  "y": 70
                                },
                                {
                                  "x": "03:00",
                                  "y": 70
                                },
                                {
                                  "x": "04:00",
                                  "y": 70
                                },
                                {
                                  "x": "05:00",
                                  "y": 70
                                },
                                {
                                  "x": "06:00",
                                  "y": 70
                                },
                                {
                                  "x": "07:00",
                                  "y": 70
                                },
                                {
                                  "x": "08:00",
                                  "y": 70
                                },
                                {
                                  "x": "09:00",
                                  "y": 70
                                },
                                {
                                  "x": "10:00",
                                  "y": 70
                                },
                                {
                                  "x": "11:00",
                                  "y": 70
                                },
                                {
                                  "x": "12:00",
                                  "y": 70
                                },
                                {
                                  "x": "13:00",
                                  "y": 70
                                },
                                {
                                  "x": "14:00",
                                  "y": 70
                                },
                                {
                                  "x": "15:00",
                                  "y": 70
                                },
                                {
                                  "x": "16:00",
                                  "y": 70
                                },
                                {
                                  "x": "17:00",
                                  "y": 70
                                },
                                {
                                  "x": "18:00",
                                  "y": 70
                                },
                                {
                                  "x": "19:00",
                                  "y": 70
                                },
                                {
                                  "x": "20:00",
                                  "y": 70
                                },
                                {
                                  "x": "21:00",
                                  "y": 70
                                },
                                {
                                  "x": "22:00",
                                  "y": 70
                                },
                                {
                                  "x": "23:00",
                                  "y": 70
                                },
                                {
                                  "x": "24:00",
                                  "y": 70
                                }
                              ]
                            }
                          ],
                          "categories": null,
                          "xAxisType": "number",
                          "markerSize": 3,
                          "columnWidth": 20,
                          "colors": [
                            Theme.color['palette-1'],
                            Theme.color['palette-2']
                          ]
                        },
                      },
                    ],
                  }}
                />
              </Col>
              <Col span={16}>
                <Widget
                  className="full-h"
                  data={{
                    background: "white",
                    title: t("Types of Access"),
                    icon: null,
                    charts: [
                      {
                        chartType: 'horizontalStackedBarChart',
                        chartId: 'horizontalStackedBarChartTwo',
                        height: '200px',
                        data: sereializeOccupationByPaymentType(t)
                      }
                    ],
                  }}
                />
              </Col>
              <Col span={8}>
                <Widget
                  data={{
                    background: "white",
                    title: t("Occupation by type of place"),
                    icon: null,
                    charts: [
                      {
                        chartType: "columnsChartApex",
                        chartId: "columnsChartApexOne",
                        height: "200px",
                        data: {
                          "series": [
                            {
                              "name": 2024,
                              "data": [
                                {
                                  "x": t("Employees"),
                                  "y": 37
                                },
                                {
                                  "x": t("Clients"),
                                  "y": 6
                                },
                                {
                                  "x": t("Visitors"),
                                  "y": 7
                                }
                              ]
                            }
                          ],
                          "categories": [],
                          "xAxisType": null,
                          "labelFormat": null,
                          "tooltip": null,
                          "unit": "",
                          "columnWidth": 20,
                          "xAxisLabel": null,
                          "yAxisLabel": "",
                          "colors": [Theme.color['palette-6']],
                          "formatterType": null,
                          "tickAmount": 12,
                          "filename": "Gráfico exportado",
                          "headerValue": "valores",
                          "headerCategory": "categorias",
                          "showTooltipTitle": true
                        },
                      },
                    ],
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </PageContent>
    </>
  );
};

const sereializeOccupationByPaymentType = (t) => {
  const result = {
    "data": [
      {
        name: t('Access'),
        values: [
          {
            name: t("Agreements"),
            value: 180,
          },
          {
            name: t("Reservations"),
            value: 201,
          },
          {
            name: t("Free Access"),
            value: 122,
          },
        ],
      },
    ],
    "showLegend": true,
    "colors": [
      Theme.color['palette-3'],
      Theme.color['palette-4'],
      Theme.color['palette-5']
    ],
    "id": "horizontalStackedBarChartOne",
    "title": null,
    "withBarValues": false,
    "legends": false,
    "withLineValues": true,
    "xAxisLabel": null,
    "yAxisLabel": "",
    "hideAxis": true,
    "margins": {
      "left": 20,
      "right": 20
    },
    "barSize": 56
  }
  return result;
}

const parking = {
  "seatsTaken": {
    "number": 50,
    "unit": null,
    "type": null,
    "label": null,
    "fluctuation": null,
    "fluctuationText": null,
    "bigFluctuation": false,
    "icon": null
  },
  "reservedSeats": {
    "number": 45,
    "unit": "",
    "type": null,
    "label": null,
    "fluctuation": null,
    "fluctuationText": null,
    "bigFluctuation": false,
    "icon": null
  },
  "averageLengthStay": {
    "number": "5:22",
    "unit": "h",
    "type": null,
    "label": null,
    "fluctuation": null,
    "fluctuationText": null,
    "bigFluctuation": false,
    "icon": null
  },
  "seatAvailability": {
    "number": 25,
    "unit": "%",
    "type": null,
    "label": null,
    "fluctuation": null,
    "fluctuationText": null,
    "bigFluctuation": false,
    "icon": null
  },
  "occupationPaymentType": {
    "series": [
      {
        "name": "ETAR Freixo",
        "value": 595092,
        "id": "82c6e0b7-f6be-0738-1742-a5c87258700e"
      },
      {
        "name": "Biblioteca Municipal Almeida Garret",
        "value": 75712,
        "id": "b8c5c342-c4cf-fe33-32d4-3ab2918907f2"
      },
      {
        "name": "Edifício dos Correios (Câmara)",
        "value": 62698,
        "id": "e4c5c342-c924-3193-c1e2-f8ea6c49cd54"
      },
      {
        "name": "Oficinas Gerais - Posto de Transformação Multiserviços",
        "value": 39698,
        "id": "70c5c342-f05b-7f11-87df-00c68e78c482"
      },
      {
        "name": "Edifício Parque da Cidade",
        "value": 34713,
        "id": "76c5c342-7c3c-bad3-ebac-60a0ed5a1c82"
      }
    ],
    "categories": null,
    "xAxisType": null,
    "labelFormat": null,
    "tooltip": null,
    "markerSize": null,
    "unit": "",
    "columnWidth": 20,
    "xAxisLabel": "",
    "colors": null,
    "filename": "Gráfico exportado",
    "headerValue": "valores",
    "headerCategory": "Instalação",
    "hrefItem": "/home/register/registerDetail/"
  }
};